var ColumnsFilters = (function() {

  var timeout = 1000;

  var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  function intMatchFilterAttributeInit(table, filterTd, column) {
    $('input', filterTd).closest('th').addClass('intMatchFilter');
    $('input', filterTd).on('keyup change', function () {
      delay(function () {
        var value = $('input', filterTd).val();
        if (column.search() !== value) {
          column.search(value).draw();
        }
      }, timeout);
    });
  }

  function stringContainsFilterAttributeInit(table, filterTd, column) {
    $('input', filterTd).closest('th').addClass('stringContainsFilter');
    $('input', filterTd).on('keyup change', function () {
      delay(function () {
        var value = $('input', filterTd).val();
        if (column.search() !== value) {
          column.search(value).draw();
        }
      }, timeout);
    });
  }

  function dateRangeFilterAttributeInit(table, filterTd, column) {
    $('input', filterTd).closest('th').addClass('dateRangeFilter');

    var onChange = function() {
      var value = "" + $('#from', filterTd).val() + "|" + $('#to', filterTd).val();
      if (column.search() !== value) {
        column.search(value).draw();
      }
    }

    var initChange = function () {
      delay(onChange, timeout);
    }

    dateRangeInit({
      $inputFrom: $('#from', filterTd),
      $inputFromOnChangeFunc: initChange,
      $inputTo: $('#to', filterTd),
      $inputToOnChangeFunc: initChange,
      format: 'dd.mm.yyyy',
      showClear: true

    });
  }

  function dateFilterAttributeInit(table, filterTd, column) {
      $('input', filterTd).closest('th').addClass('dateFilter');

      var onChange = function () {
          var value =  $('#date', filterTd).val();
          if (column.search() !== value) {
              column.search(value).draw();
          }
      }

      var initChange = function () {
          delay(onChange, timeout);
      }

      datepickerInit({
          $input: $('#date', filterTd),
          $inputOnChangeFunc: initChange,
          format: 'dd.mm.yyyy',
          showClear: true
      });
  }

  function decimalRangeFilterAttributeInit(table, filterTd, column) {
    $('input', filterTd).closest('th').addClass('decimalRangeFilter');
    var onChange = function () {
      var value = "" + $('#from', filterTd).val() + "|" + $('#to', filterTd).val();
      if (column.search() !== value) {
        column.search(value).draw();
      }
    }

    $('#from', filterTd).on('keyup change', function () {
      delay(onChange, timeout);
    });
    $('#to', filterTd).on('keyup change', function () {
      delay(onChange, timeout);
    });
  }

  function doubleRangeFilterAttributeInit(table, filterTd, column) {
    $('input', filterTd).closest('th').addClass('doubleRangeFilter');
    var onChange = function () {
      var value = "" + $('#from', filterTd).val() + "|" + $('#to', filterTd).val();
      if (column.search() !== value) {
        column.search(value).draw();
      }
    }

    $('#from', filterTd).on('keyup change', function () {
      delay(onChange, timeout);
    });
    $('#to', filterTd).on('keyup change', function () {
      delay(onChange, timeout);
    });
  }

  function roadSectionServicesCategoriesFilterAttributeInit(table, filterTd, column) {
    $('input', filterTd).closest('th').addClass('roadSSegmentsCategoriesFilter');
    $('input', filterTd).on('keyup change', function () {
      delay(function () {
        var value = $('input', filterTd).val();
        if (column.search() !== value) {
          column.search(value).draw();
        }
      }, timeout);
    });
  }

  function dropDownFilterAttributeInit(table, filterTd, column) {
    $('select', filterTd).closest('th').addClass('dropDownFilter');
    $('select', filterTd).on('change', function () {
      var control = $(this);
      delay(function () {
        var value = control.val();
        if (column.search() !== value) {
          column.search(value).draw();
        }
      }, timeout);
    });
  }
  


  return {
    intMatchFilterAttributeInit: intMatchFilterAttributeInit,
    stringContainsFilterAttributeInit: stringContainsFilterAttributeInit,
    dateRangeFilterAttributeInit: dateRangeFilterAttributeInit,
    dateFilterAttributeInit: dateFilterAttributeInit,
    decimalRangeFilterAttributeInit: decimalRangeFilterAttributeInit,
    doubleRangeFilterAttributeInit: doubleRangeFilterAttributeInit,
    roadSectionServicesCategoriesFilterAttributeInit: roadSectionServicesCategoriesFilterAttributeInit,
    dropDownFilterAttributeInit: dropDownFilterAttributeInit
  }
})();